/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

const PanelContent = {
  baseStyle: {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    ms: "auto",
    me: "auto",
    ps: "15px",
    pe: "15px",
    overflowX: "hidden",
    "& > *": {
      minWidth: 0,
    },
  },
};

export const PanelContentComponent = {
  components: {
    PanelContent,
  },
};
